<style lang="scss" scoped>
</style>

<template>
    <nav id="sidebar" class="fixed top-0 flex flex-col w-full h-full z-2000 text-secondary-400 text-lg xl:text-xl 2.5xl:text-1.5xl transition-all !duration-500" :class="!show ? 'opacity-0 pointer-events-none' : ''">
        <div class="h-full p-12 flex-grow z-2000 bg-[#0a0a0a] w-[360px] max-w-[500px] sm:w-auto -right-[500px] absolute top-0 transition-all !duration-500" :class="show ? '!right-0' : ''">
            <div class="h-full px-3">
                <div class="flex flex-col h-full px-0 mt-0">
                    <button type="button" class="absolute w-8 h-8 transition-all top-6 right-4 hover:opacity-80" @click="show = false">
                        <img class="w-6 h-6" width="26" src="/images/svg/close.svg" alt="chiudi"/>
                    </button>
                    <div class="flex-grow overflow-auto">
                        <div class="mt-2 mb-5 text-left">
                            <span class="mb-5 text-[18px] md:text-[19px] xl:text-[20px] text-center text-primary-300">{{$root.translateString('products_in_total')}}:&nbsp; <span>({{countProducts}})</span></span>
                        </div>
                        <div class="space-y-3">
                            <div class="flex items-start w-full" v-for="(item, key) in cart" :key="key">
                                <div class="flex items-center justify-center w-16 h-16 p-3 min-w-16 xs:w-20 xs:min-w-20 xs:h-20 md:w-22 md:min-w-22 md:h-22 bg-white/10">
                                    <img width="70" class="object-contain w-full h-full" :src="item.options.image" :alt="item.options.name" />
                                </div>
                                <div class="flex flex-col flex-grow pl-6">
                                    <div class="flex flex-grow w-full pt-0 pl-0">
                                        <span class="pr-2 h-full whitespace-nowrap !leading-snug relative -top-1">{{item.qty}} x</span>
                                        <span class="flex flex-col flex-grow">
                                            <span class="uppercase text-white !leading-tight text-lg" v-text="item.options.name"></span>
                                            <span class="w-full flex flex-col text-lg !leading-snug -mt-0.5">
                                                <span class="w-full" v-if="item.options.type == 'vini'" v-text="item.options.combination"></span>
                                                <span class="w-full" v-else-if="item.options.type == 'visite'">
                                                    {{parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids)}}
                                                    <span v-if="item.options.visit.adults==1">{{$root.translateString('person')}}</span>
                                                    <span v-else>{{$root.translateString('people')}}</span>
                                                    <span v-if="item.options.combination">
                                                        -
                                                    {{item.options.combination.replace(" ", "")}}
                                                    </span>
                                                </span>
                                                <span class="w-full" v-else>Cantina Letrari</span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="flex items-center flex-grow py-0 pl-0 mt-2">
                                        <span class="flex-grow text-base">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </span>
                                        <a class="inline-flex items-center space-x-2 transition-all hover:text-white" href="javascript:void(0)" @click="updateCart(key, 0)">
                                            <img class="w-3.5 h-3.5" src="/images/svg/icon-remove.svg" alt="icona" />
                                            <span class="text-base">{{$root.translateString('remove')}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center justify-center w-full px-6 py-2 my-4 bg-primary-400/20">
                        <span class="text-[15px] uppercase text-white !tracking-[0.05em]">{{$root.translateString('free_shipping')}} <span>€110</span></span>
                    </div>

                    <div class="pb-4 mb-4 text-center border-b text-primary-300 border-white/30" v-if="missing_for_free_shipping > 0">
                       <span v-if="lang == 'it'">
                           Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                       </span>
                        <span v-else>
                           € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                       </span>
                    </div>

                    <div class="flex pb-2">
                        <div class="flex-grow">{{$root.translateString('subtotal')}}</div>
                        <div class="">
                            € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                        </div>
                    </div>

                    <div class="flex pb-4 spedizione" v-if="should_be_shipped">
                        <div class="flex-grow">{{$root.translateString('shipping')}}</div>
                        <div class="">
                            <span v-if="shipping > 0">
                                 € {{ $root.currencyDisplaySimple(shipping) }}
                            </span>
                            <span v-else>{{$root.translateString('free')}}</span>
                        </div>
                    </div>

                    <div class="flex pb-4 spedizione" v-if="discount > 0">
                        <div class="flex-grow">{{$root.translateString('discount')}}</div>
                        <div class="">
                            € {{ $root.currencyDisplaySimple(discount) }}
                        </div>
                    </div>

                    <div class="flex py-3 border-t border-white/30">
                        <div class="flex flex-col flex-grow">
                            <div class="text-white">{{$root.translateString('total')}}</div>
                            <small class="-mt-2">{{$root.translateString('tax_included')}}</small>
                        </div>
                        <div class="text-white"> € {{ $root.currencyDisplaySimple(finalPrice) }} </div>
                    </div>

                    <div class="w-full pt-2 mt-4 mb-2 text-center">
                        <div class="flex w-full">
                            <a :href="$root.langRoute('/carrello')" class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all">
                                <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                                    {{$root.translateString('go_to_cart')}}
                                </span>
                                <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                                <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="fixed top-0 left-0 w-full h-full z-1000" style="background-color:rgba(13, 13, 13, .82)" @click="show = false"></div>
    </nav>
</template>
<script>
export default {
    props: ['lang'],
    data() {
        return {
            show:false,
            cartRaw: null,
            should_be_shipped: false,
            priceTotalWt: 0,
            finalPrice: 0,
            shipping: 0,
            discount: 0,
            missing_for_free_shipping: 0,
        }
    },
    mounted() {
        this.getCart();

        this.$eventHub.$on('cart.show', payload => {
            this.show = true;
        });

        this.$eventHub.$on('cart.added', payload => {
            this.getCart();
        });

        this.$eventHub.$on('cart.updated', payload => {
            this.getCart();
        });

    },
    methods: {
        setCookie(key, value, expiry) {
            let expires = new Date();
            expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
            document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
        },

        getCookie(key) {
            let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
            return keyValue ? keyValue[2] : null;
        },
        emptyCart() {
            axios.post('/api/cart/empty', {})
            .then(response => {
                this.cartRaw = null;
                this.shipping = 0;
                this.priceTotalWt = 0;
                this.finalPrice = 0;
                this.discount = 0;
                this.missing_for_free_shipping = 0;
            })
        },
        updateCart(key, value) {

            axios.post('/api/cart/update', {
                'key': key,
                'qty': value,
            })
            .then(response => {
                this.getCart();

                let update_type = 'add';
                let quantity_to_track = value;

                if(quantity_to_track == 0) {

                    quantity_to_track = this.cart[key].qty;

                    /*gtag('event', 'remove_from_cart', {
                        "items": [
                            {
                                'name': this.cart[key].options.name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Cantina Letrari',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });*/


                }else{

                    /*gtag('event', 'add_to_cart', {
                        "items": [
                            {
                                'name': this.cart[key].name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Cantina Letrari',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });*/

                }

                this.setCookie('cartIsFull', this.countProducts, '1');

                this.$eventHub.$emit('cart.updated');
                this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));
            })
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.cartRaw = response.data.cart;
                this.shipping = response.data.shipping;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.discount = response.data.discount;
                this.should_be_shipped = response.data.shouldBeShipped;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;

                if(_.isEmpty(this.cart)) {
                    this.show = false;
                }

            })
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.show');
        this.$eventHub.$off('cart.updated');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }

            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }

            return tmp;
        },
        countProducts() {

            if(!this.isNotEmpty(this.cart)) {
                return 0;
            }

            let count = 0;

            for (let [key, item] of Object.entries(this.cart)) {
                count += item.qty;
            };

            return count;
        }
    }
}
</script>
